'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var commaSeparate = exports.commaSeparate = function commaSeparate() {
  var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var maxDisplayCount = arguments[1];

  var items = string.split(', ');
  var truncatedItems = items.slice(0, maxDisplayCount);
  var truncatedItemsString = truncatedItems.join(', ');

  if (items.length > maxDisplayCount) {
    return truncatedItemsString + ', \u2026';
  }
  return truncatedItemsString;
};